import React, { useEffect } from 'react';
import './Visionneuse.css';

// Visionneuse de justificatif : plein écran dans la page, sans onglet séparé.
// Fermeture : croix, touche Échap, ou clic sur le fond sombre.
function Visionneuse({ url, type, titre, onClose }) {
  useEffect(() => {
    const surTouche = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', surTouche);
    const scrollAvant = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', surTouche);
      document.body.style.overflow = scrollAvant;
    };
  }, [onClose]);

  if (!url) return null;
  const estPdf = (type || '').includes('pdf');

  return (
    <div className="vz-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-label={titre || 'Justificatif'}>
      <button type="button" className="vz-fermer" onClick={onClose} aria-label="Fermer">✕</button>
      {titre && <div className="vz-titre">{titre}</div>}
      <div className="vz-contenu" onClick={(e) => e.stopPropagation()}>
        {estPdf ? (
          <>
            <iframe src={url} title={titre || 'Justificatif PDF'} className="vz-pdf" />
            <a href={url} target="_blank" rel="noreferrer" className="vz-onglet">
              Si le PDF ne s'affiche pas : ouvrir dans un onglet ↗
            </a>
          </>
        ) : (
          <img src={url} alt={titre || 'Justificatif'} className="vz-image" />
        )}
      </div>
    </div>
  );
}

export default Visionneuse;
